import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/reports/")({
  component: ReportsIndexPage,
});

function ReportsIndexPage() {
  return (
    <div className="flex h-64 items-center justify-center">
      <div className="text-center">
        <h3 className="subtitle text-foreground mb-2">Welcome to Reports</h3>
        <p className="body text-foreground mb-4">
          Select a report type and location from the filters above to get
          started.
        </p>
        <div className="body-sm text-foreground">
          All reports are location-specific and require both a report type and
          location selection.
        </div>
      </div>
    </div>
  );
}
